<template>
    <div class="popup account-dialog">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <span> {{ $t("person.PersonalCenter") }} </span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation" class="icon-base_root-F1flk icon-base_m-F1flk" data-icon="close" @click="close">
                        <path fill="currentColor"
                            d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                            clip-rule="evenodd"></path>
                    </svg>
                </div>
                <person ref="person" class="account-dashboard--panel"></person>
            </div>
        </van-popup>
    </div>
</template>

<script>
import person from '@/views/person/index.vue'
export default {
    name: 'my',
    data() {
        return {
            isFirstReload: true
        }
    },
    components: {
        person
    },
    computed: {
        show: {
            get() {
                return this.$store.getters.isShowMyPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
        },
        open() {
            this.$nextTick(() => {
                this.$refs.person.init()
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            min-height: 500px;
            width: 470px;
            max-height: calc(100% - 48px);
            max-width: calc(100% - 48px);
            margin: 24px;
            pointer-events: auto;
            contain: layout;
            outline: none;
            background:
                var(--aurora-soft-gradient);
            box-shadow: 0 .18rem .44rem var(--aurora-shadow-color), inset 0 1px 0 var(--aurora-shadow-color);
            border-radius: 20px !important;
            display: flex;
            flex-direction: column;
            // overflow: auto;

            .header{
                font-size: 20px;
                margin: 20px 20px 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: var(--aurora-ink);
                font-size: .36rem;
                text-shadow: 0 1px 2px var(--aurora-shadow-color);

                svg{
                    width: .42rem;
                    height: .42rem;
                    color: var(--aurora-ink);
                    cursor: pointer;
                }
            }

            ::v-deep .pages{
                background: transparent;
                flex: 1;
                overflow: auto;
            }

            ::v-deep .pages::-webkit-scrollbar {
                width: 8px;
            }

            ::v-deep .pages::-webkit-scrollbar-thumb {
                background: var(--aurora-soft-gradient);
                border-radius: 999px;
            }

            ::v-deep .pages::-webkit-scrollbar-track {
                background: var(--aurora-surface);
                border-radius: 999px;
            }

            ::v-deep .pages .func_btns > div {
                background:
                    var(--aurora-soft-gradient) !important;
                color: var(--aurora-ink) !important;
                border: 1px solid var(--aurora-line) !important;
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
            }

            ::v-deep .pages .func_btns > div:first-child {
                background:
                    var(--aurora-soft-gradient) !important;
                color: var(--aurora-ink) !important;
                border-color: var(--aurora-line) !important;
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
            }

            ::v-deep .pages .func_btns > div:last-child {
                background:
                    var(--aurora-soft-gradient) !important;
                color: var(--aurora-ink) !important;
                border: 1px solid var(--aurora-line) !important;
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
            }
        }
    }
}
</style>
